export const SHANGHAI_TIME_ZONE = 'Asia/Shanghai'
const parts = new Intl.DateTimeFormat('en-CA', {
  timeZone: SHANGHAI_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
})

function systemDate(value: string | Date) {
  if (value instanceof Date) return value
  const trimmed = value.trim()
  const normalized = /[T ]\d{2}:\d{2}/.test(trimmed) && !/(?:Z|[+-]\d{2}:?\d{2})$/i.test(trimmed)
    ? `${trimmed.replace(' ', 'T').replace(/(\.\d{3})\d+/, '$1')}Z`
    : trimmed
  return new Date(normalized)
}

export function shanghaiSignalTime(date: string, time = '14:30') {
  return `${date}T${time}:00+08:00`
}

export function formatBusinessDateTime(
  value: string | Date | null | undefined,
  fallback = '—',
) {
  if (!value) return fallback
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return `${value} 00:00:00`
  const date = systemDate(value)
  if (Number.isNaN(date.getTime())) return typeof value === 'string' ? value : fallback
  const values = Object.fromEntries(
    parts.formatToParts(date).map(part => [part.type, part.value]),
  )
  return `${values.year}-${values.month}-${values.day} ${values.hour}:${values.minute}:${values.second}`
}
